<script lang="ts" setup>
import cms from '@/api/cms';
import { onMounted, ref } from 'vue'; 

import { useModalsStore } from '@/stores/modals';
import { useUserStore } from '@/stores/user';
import { getStaticImages } from '@/utils';

const { isLoggedIn } = useUserStore();
const { toggleModal } = useModalsStore();

const promos: any = ref([]);
const props = defineProps<{ pageData: string }>();

onMounted(load);

async function load() {
    loadPromos();
}

async function loadPromos(){
    const { result, error } = await cms();

    if(error){
        return;
    }

    // //Position 1 means that it's actually a promo in the CMS
    if(!result!.length){
        return;
    }

    promos.value = result!.filter(promo => promo.position === 1);
}

</script>

<template src="./promos.html"></template>